import { Table, TableProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { MostQuerySuggestedTask } from 'src/graphql/generated/graphql';
import { getTableConfig } from './config';
import styles from './table.module.css';

type MostHistoryTableProps = Omit<TableProps, 'columns'> & {
  data: MostQuerySuggestedTask[];
  store: {
    id: string;
    nationalStoreNumber: string;
  };
};

export const MostHistoryTable = ({
  data,
  store,
  ...props
}: MostHistoryTableProps) => {
  const { t } = useTranslation();

  const tableConfig = getTableConfig(data || [], store, { t });

  return (
    <div className={styles.tableWrapper}>
      <Table {...props} data={data} columns={tableConfig} />
    </div>
  );
};
